import i18n from "@/i18n/i18n";
import * as signalR from "@microsoft/signalr";
import { Message } from "element-ui";
import { VideoCallRoom } from "@/api/videoCall";
import { History } from "@/api/history";
import dayjs from "dayjs";

const state = {
  connection: null,
  hubUrl: process.env.VUE_APP_BASEURL + "/videoCall",
  videoCallRoomData: [],
  messageCenter: null,
};

const actions = {
  stopConnection({ commit }) {
    state.connection.stop().then(() => {
      // console.log('connection stop.');
    });
    commit("cleanConnection");
  },
  initConnection({ state, dispatch }, payload) {
    console.log("1. 初始化 videoCall connection (new signalR)");
    state.connection = new signalR.HubConnectionBuilder()
      .withUrl(state.hubUrl, {
        accessTokenFactory: () => localStorage.getItem("AC_token"),
      })
      .configureLogging(signalR.LogLevel.Debug)
      .build();
    dispatch("startConnection");
  },
  startConnection({ state, dispatch }) {
    state.connection
      .start()
      .then(function () {
        dispatch("onReady");
        // console.log("2. internalChat connection onReady");
      })
      .catch((error) => {
        // console.log("(連線錯誤)Error establishing the connection: ", error);
      });
  },
  // on listen
  onReady({ rootState, state, dispatch, commit }) {
    state.connection.on("onError", function (message) {
      console.log("connection onError", message);
      Message({
        message: message,
        center: true,
        iconClass: "el-icon-circle-close",
        customClass: "msg msg-error",
        duration: 5000,
        showClose: true,
      });
    });
    state.connection.on("LoadVideoCallRoom", function (data) {
      commit("setVideoCallRoom", data);
    });
    state.connection.on("leaveRoom", function (data) {
      commit("finishVideoCallRoom", data);
      dispatch("getVideoCallRoomInfo", data.videoCallRoomId);
    });
    state.connection.on("ChatFinish", function (data) {
      Message({
        message: i18n.t("VIDEOCALL.CUSTOMER_ENDED"),
        center: true,
        iconClass: "el-icon-circle-close",
        customClass: "msg msg-warning",
        duration: 5000,
        showClose: true,
      });
      dispatch("videoCallRTC/hangup", "", { root: true });
      commit("finishVideoCallRoom", data);
      dispatch("getVideoCallRoomInfo", data.videoCallRoomId);
    });
    state.connection.on("VideoCallSurveyResult", function (data) {
      commit("updateSurveyResult", data);
    });
    state.connection.on("receiveSignal", (data) => {
      dispatch("videoCallRTC/receiveSignal", data, { root: true });
    });
    state.connection.on("agentOnline", () => {});
    state.connection.on("RemoveLeaveRoomUser", () => {});
  },
  // 建立Video Room
  createNewVideoCallRoom({ state }, payload) {
    VideoCallRoom.Create(payload).then((res) => {
      // console.log("createNewInternalRoom", res);
      state.connection.invoke("LoadVideoCallRoomList");
    });
  },
  // Agent 離開 Room
  hangUpByAgent({ state, commit }, payload) {
    state.connection.invoke("HangUpByAgent", payload);
    commit("finishVideoCallRoom", payload);
  },
  sendSignalToCustomer({ state }, payload) {
    let data = {
      signal: payload.signal,
      videoCallRoomId: payload.videoCallRoomId,
    };
    // console.log("sendSignalToAgent", data);
    state.connection.invoke("sendSignalToCustomer", data);
  },
  async getVideoCallRoomInfo({ commit }, roomId) {
    if (!roomId) return;
    try {
      const res = await History.GetVideoCallDetail({ roomId });
      commit("updateVideoCallRoom", res.data);
    } catch (error) {
      console.log("getVideoCallRoomInfo error: ", error);
    }
  },
};
const mutations = {
  setLoading(state, payload) {
    state.loading = payload;
  },
  cleanConnection(state) {
    state.connection = null;
    state.videoCallRoomData = null;
  },
  // 初始化聊天室
  setVideoCallRoom(state, payload) {
    state.videoCallRoomData = payload;
  },
  finishVideoCallRoom(state, payload) {
    state.videoCallRoomData.forEach((el, i) => {
      if (el.id == payload.videoCallRoomId) {
        state.videoCallRoomData[i].isFinished = true;
      }
    });
  },
  updateVideoCallRoom(state, payload) {
    console.log('updateVideoCallRoom', payload);
    state.videoCallRoomData.forEach((el, i) => {
      if (el.id == payload.id) {
        state.videoCallRoomData.splice(i, 1, payload);
      }
    });
  },
  updateSurveyResult(state, payload) {
    let room = state.videoCallRoomData.find((room) => {
      return room.id == payload.videoCallRoomId;
    });
    room.isSatisfied = payload.isSatisfied;
  },
};
const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
